import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { AuditCategoryName } from '@portal-core/notifications/enums/audit-category-name.enum';
import { NotificationPage } from '@portal-core/notifications/models/notification-page.model';
import { Notification } from '@portal-core/notifications/models/notification.model';
import { NotificationList } from '@portal-core/notifications/util/notification-list';
import { filter as _filter } from 'lodash';
import { Observable } from 'rxjs';
import { NotificationListComponent } from '@portal-core/notifications/components/notification-list/notification-list.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'mc-task-notification-list',
    templateUrl: './task-notification-list.component.html',
    styleUrls: ['./task-notification-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NotificationListComponent, NgIf, MatButton, MatProgressBar, AsyncPipe]
})
export class TaskNotificationListComponent extends NotificationList implements OnChanges, OnInit {
  @HostBinding('class.mc-notification-list') notificationListClass: boolean = true;
  @Input() taskBoardId: number;
  @Input() licenseId: number;

  override ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licenseId || changes.taskBoardId) {
      this.onConfigurationChanged();
    }
  }

  protected isConfigured(): boolean {
    return typeof this.licenseId === 'number';
  }

  protected fetchNotifications$(pageSize: number, pageIndex: number): Observable<NotificationPage> {
    return this.notificationsService.getTaskNotificationsByLicenseId$(this.licenseId, pageSize, pageIndex, this.taskBoardId);
  }

  protected filterNotifications(notifications: { [id: string]: Notification }): Notification[] {
    return _filter(notifications, (notification: Notification) => {
      return notification.LicenseId === this.licenseId && notification.Category
        && (this.taskBoardId == null || notification.TaskBoardId === this.taskBoardId)
        &&
        (
          notification.Category.Name === AuditCategoryName.Tasks ||
          notification.Category.Name === AuditCategoryName.TaskDeleted ||
          notification.Category.Name === AuditCategoryName.TaskNewOrAssigned ||
          notification.Category.Name === AuditCategoryName.TaskEdited ||
          notification.Category.Name === AuditCategoryName.TaskCommentsorFileActions ||
          notification.Category.Name === AuditCategoryName.TaskStatusChanged ||
          notification.Category.Name === AuditCategoryName.TaskBoardCreated ||
          notification.Category.Name === AuditCategoryName.TaskBoardDeleted ||
          notification.Category.Name === AuditCategoryName.TaskBoardEdited
        );
    });
  }
}
